export default {
  dataTimePattern: "YYYY-MM-DD HH:mm:ss",
  datePattern: "yyyy-MM-DD"
}